module.exports = __webpack_public_path__ + "static/media/10_profile_picture.b7b7c0c5.png";